export const leadButtonCopyPlural = "Zapytaj o ceny";
export const leadButtonCopyPlural = "Zapytaj o ceny";
